import { Box, Typography, alpha, useTheme } from '@mui/material';

const CATEGORY_COLORS = {
  Search: '#4caf50',
  Conversation: '#2196f3',
  Contract: '#ff9800',
  Signature: '#9c27b0',
  Navigation: '#607d8b',
};

const UserFeatureUsage = ({ featureUsage }) => {
  const theme = useTheme();

  if (!featureUsage || featureUsage.length === 0) {
    return (
      <Box sx={{
        p: 3, mb: 3, borderRadius: '12px',
        border: `1px solid ${theme.palette.divider}`,
        bgcolor: theme.palette.background.paper,
      }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>Feature Usage</Typography>
        <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>No feature usage data.</Typography>
      </Box>
    );
  }

  const total = featureUsage.reduce((acc, f) => acc + f.count, 0);
  const maxCount = Math.max(...featureUsage.map((f) => f.count), 1);

  return (
    <Box sx={{
      p: 3, mb: 3, borderRadius: '12px',
      border: `1px solid ${theme.palette.divider}`,
      bgcolor: theme.palette.background.paper,
    }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, color: theme.palette.text.primary }}>
        Feature Usage
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {featureUsage.slice(0, 10).map((f) => {
          const color = CATEGORY_COLORS[f.category] || theme.palette.primary.main;
          const pct = total > 0 ? Math.round((f.count / total) * 100) : 0;
          const barWidth = (f.count / maxCount) * 100;

          return (
            <Box key={f.category}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                <Typography variant="body2" sx={{ fontWeight: 500, color: theme.palette.text.primary }}>
                  {f.category}
                </Typography>
                <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                  {f.count} ({pct}%)
                </Typography>
              </Box>
              <Box sx={{ height: 8, borderRadius: 4, bgcolor: alpha(color, 0.1), overflow: 'hidden' }}>
                <Box sx={{
                  height: '100%', borderRadius: 4, bgcolor: color,
                  width: `${barWidth}%`, transition: 'width 0.5s ease',
                }} />
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default UserFeatureUsage;
